import axios from '@_system/axios/axios.js'
export default {
	path: '/supplierscore',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updatescore(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updatescore', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	listscore(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/listscore', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	cancelscore(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/cancelscore', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/supplier.supplierscore', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
}
